// extracted by mini-css-extract-plugin
export default {"beat":"Interval_beat__VD5ou","LeadTitle":"Interval_LeadTitle__oSmeV","LeadTitleDelete":"Interval_LeadTitleDelete__0l4Vq"};